import { render } from "./MarketSummary.vue?vue&type=template&id=2b75c8da"
import script from "./MarketSummary.vue?vue&type=script&lang=js"
export * from "./MarketSummary.vue?vue&type=script&lang=js"

import "./MarketSummary.vue?vue&type=style&index=0&id=2b75c8da&lang=scss"
script.render = render

export default script